import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import Sidebar from "../components/Sidebar/Sidebar.jsx";
import Navbar from "../components/Navbar/Navbar";

import "./UserLayout.scss";

const UserLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  /* ---------------------------------------------------------
     Close sidebar when moving to desktop
     --------------------------------------------------------- */
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 900) {
        setIsSidebarOpen(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  /* ---------------------------------------------------------
     Make sure this layout never locks page scrolling
     --------------------------------------------------------- */
  useEffect(() => {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";

    return () => {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div
      className={`admin-layout ${
        isSidebarOpen ? "with-sidebar" : "no-sidebar"
      }`}
    >
      {/* =====================================================
          SIDEBAR
      ===================================================== */}
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

      {/* =====================================================
          SIDEBAR TOGGLE
      ===================================================== */}
      <button
        type="button"
        className="sidebar-toggle"
        onClick={() => setIsSidebarOpen((prev) => !prev)}
        aria-label={
          isSidebarOpen ? "Close navigation menu" : "Open navigation menu"
        }
        aria-expanded={isSidebarOpen}
      >
        {isSidebarOpen ? "✕" : "☰"}
      </button>

      {/* =====================================================
          MAIN CONTENT
      ===================================================== */}
      <div className="admin-main-content">
        {/* ===================================================
            FIXED NAVBAR
        =================================================== */}
        <div className="user-navbar">
          <Navbar />
        </div>

        {/* ===================================================
            DASHBOARD CONTENT
        =================================================== */}
        <main className="admin-data-section">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default UserLayout;
